import React, { useRef, useState } from "react";
import Navbar from "../components/Navbar";
import HomeSection from "../components/HomeSection";
import UploadScan from "../components/UploadScan";
import ScanHistory from "../components/ScanHistory";
import Footer from "../components/Footer";


export default function MainPage() {
  const homeRef = useRef(null);
  const uploadRef = useRef(null);
  const historyRef = useRef(null);

  // Shared state for reports
  const [newReport, setNewReport] = useState(null);

  return (
    <>
      <Navbar refs={{ homeRef, uploadRef, historyRef }} />

      <div ref={homeRef}>
        <HomeSection />
      </div>

      <div ref={uploadRef}>
        {/* Pass callback to UploadScan */}
        <UploadScan onNewReport={setNewReport} />
      </div>

      <div ref={historyRef}>
        {/* Pass newReport to ScanHistory */}
        <ScanHistory newReport={newReport} />
      </div>
      <Footer />
    </>
  );
}